import { en } from './en'
import { fr } from './fr'

export const landingPageForCompanies = {
  en,
  fr
}